var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#605E5C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.242 8.58541L8.27044 14.5584C7.95004 14.8788 7.54859 15.1061 7.10901 15.216L4.81801 15.7887C4.45182 15.8803 4.12013 15.5486 4.21167 15.1824L4.78442 12.8914C4.89432 12.4518 5.12162 12.0503 5.44201 11.7299L11.4136 5.75698L14.242 8.58541ZM15.6569 4.34348C16.4379 5.12453 16.4379 6.39086 15.6569 7.1719L14.9491 7.8783L12.1207 5.04988L12.8285 4.34348C13.6095 3.56243 14.8759 3.56243 15.6569 4.34348Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.639361c9fb7a6c5d244f93e97dd8ffd3.svg";
export { ForwardRef as ReactComponent };